import React, { useState, useEffect } from 'react';
import { Shield, AlertTriangle, Download, Play, Users, Eye, X, RefreshCw, ChevronDown, ChevronUp, Bookmark, FileSpreadsheet, CheckCircle, Search, Send, Upload } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import * as XLSX from 'xlsx';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ChipDumpingTab() {
  const [loading, setLoading] = useState(false);
  const [ejecutandoAnalisis, setEjecutandoAnalisis] = useState(false);
  const [fechaDesde, setFechaDesde] = useState('');
  const [filtroJugador, setFiltroJugador] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  const [resumen, setResumen] = useState(null);
  const [alertas, setAlertas] = useState([]);
  const [filtroNivel, setFiltroNivel] = useState('');
  const [totalAlertas, setTotalAlertas] = useState(0);
  const [historial, setHistorial] = useState([]);
  const [teams, setTeams] = useState([]);

  const [showVsModal, setShowVsModal] = useState(false);
  const [vsData, setVsData] = useState(null);
  const [loadingVs, setLoadingVs] = useState(false);
  const [expandedTeam, setExpandedTeam] = useState(null);
  const [teamsGrabados, setTeamsGrabados] = useState(new Set());
  const [alertasGrabadas, setAlertasGrabadas] = useState(new Set());
  const [enviandoWA, setEnviandoWA] = useState(false);
  const [confirmadosCD, setConfirmadosCD] = useState([]);
  const [showConfirmados, setShowConfirmados] = useState(false);
  const [importandoResp, setImportandoResp] = useState(false);

  const token = localStorage.getItem('token');
  const authHeaders = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    cargarDatos();
    cargarConfirmados();
  }, []);

  useEffect(() => {
    cargarAlertas();
  }, [filtroNivel, filtroJugador]);

  const cargarConfirmados = async () => {
    try {
      const res = await axios.get(`${API}/chip-dumping/confirmados`, { headers: authHeaders });
      setConfirmadosCD(res.data.confirmados || []);
    } catch (e) {
      console.error('Error cargando confirmados CD:', e);
    }
  };

  const importarRespuestaPPPoker = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportandoResp(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axios.post(`${API}/chip-dumping/importar-respuesta-pppoker`, formData, {
        headers: { ...authHeaders, 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.success) {
        toast.success(res.data.mensaje);
        cargarConfirmados();
      } else {
        toast.error('Error al importar');
      }
    } catch (err) {
      toast.error('Error: ' + (err.response?.data?.detail || err.message));
    }
    setImportandoResp(false);
    e.target.value = '';
  };

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const histRes = await axios.get(`${API}/chip-dumping/historial`, { headers: authHeaders });
      setHistorial(histRes.data.historial || []);

      if (histRes.data.historial?.length > 0) {
        const ultimo = histRes.data.historial[0];
        setResumen(ultimo);

        // Cargar teams del ultimo analisis
        try {
          const detalleRes = await axios.get(
            `${API}/chip-dumping/analisis/${ultimo.analisis_id}`,
            { headers: authHeaders }
          );
          setTeams(detalleRes.data.teams || []);
        } catch (e) {
          console.warn('No se pudieron cargar teams:', e);
        }
      }

      await cargarAlertas();
    } catch (error) {
      console.error('Error cargando datos chip dumping:', error);
      toast.error('Error al cargar datos de chip dumping');
    } finally {
      setLoading(false);
    }
  };

  const cargarAlertas = async () => {
    try {
      const params = new URLSearchParams();
      if (filtroNivel) params.append('nivel', filtroNivel);
      if (filtroJugador) params.append('jugador', filtroJugador);
      params.append('limit', '100');

      const res = await axios.get(`${API}/chip-dumping/alertas?${params}`, { headers: authHeaders });
      setAlertas(res.data.alertas || []);
      setTotalAlertas(res.data.total || 0);
    } catch (error) {
      console.error('Error cargando alertas:', error);
    }
  };

  const ejecutarAnalisis = async () => {
    setEjecutandoAnalisis(true);
    try {
      const params = new URLSearchParams();
      if (fechaDesde) params.append('fecha_desde', fechaDesde);
      if (fechaHasta) params.append('fecha_hasta', fechaHasta);

      const res = await axios.post(`${API}/chip-dumping/analizar?${params}`, {}, { headers: authHeaders });
      toast.success(`Analisis completado: ${res.data.total_alertas} alertas encontradas`);
      setResumen(res.data);
      if (res.data.resumen_teams) {
        setTeams(res.data.resumen_teams);
      }
      await cargarDatos();
    } catch (error) {
      console.error('Error ejecutando analisis:', error);
      toast.error('Error al ejecutar analisis: ' + (error.response?.data?.detail || error.message));
    } finally {
      setEjecutandoAnalisis(false);
    }
  };

  const verDetallePar = async (brId, arId) => {
    setLoadingVs(true);
    setShowVsModal(true);
    try {
      const res = await axios.get(`${API}/chip-dumping/vs/${brId}/${arId}`, { headers: authHeaders });
      setVsData(res.data);
    } catch (error) {
      console.error('Error cargando detalle VS:', error);
      toast.error('Error al cargar detalle');
    } finally {
      setLoadingVs(false);
    }
  };

  const exportarDenuncia = async (analisisId) => {
    try {
      const params = analisisId ? `?analisis_id=${analisisId}` : '';
      const res = await axios.get(`${API}/chip-dumping/exportar-denuncia${params}`, {
        headers: authHeaders,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `chip_dumping_denuncia_${new Date().toISOString().split('T')[0]}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('Excel de denuncia descargado');
    } catch (error) {
      console.error('Error exportando:', error);
      toast.error('Error al exportar Excel');
    }
  };

  const toggleGrabarAlerta = (idx) => {
    setAlertasGrabadas(prev => {
      const next = new Set(prev);
      if (next.has(idx)) {
        next.delete(idx);
      } else {
        next.add(idx);
      }
      return next;
    });
  };

  const exportarReporteAlertas = async () => {
    const seleccionadas = [...alertasGrabadas].map(idx => alertas[idx]).filter(Boolean);
    if (seleccionadas.length === 0) {
      toast.error('No hay alertas grabadas');
      return;
    }

    try {
      const res = await axios.post(`${API}/chip-dumping/exportar-reporte-pares`, seleccionadas, {
        headers: authHeaders,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `chip_dumping_reporte_pares_${new Date().toISOString().split('T')[0]}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success(`Reporte profesional generado: ${seleccionadas.length} pares`);
    } catch (error) {
      console.error('Error generando reporte:', error);
      toast.error('Error al generar reporte');
    }
  };

  const enviarPorWhatsApp = async () => {
    const seleccionadas = [...alertasGrabadas].map(idx => alertas[idx]).filter(Boolean);
    if (seleccionadas.length === 0) {
      toast.error('No hay alertas grabadas para enviar');
      return;
    }

    setEnviandoWA(true);
    try {
      const res = await axios.post(`${API}/chip-dumping/enviar-reporte-whatsapp`, seleccionadas, {
        headers: authHeaders
      });

      if (res.data.success) {
        toast.success(`${res.data.mensaje}`);
        setAlertasGrabadas(new Set());
        await cargarAlertas();
      } else {
        toast.error(res.data.mensaje || 'Error al enviar por WhatsApp');
      }
    } catch (error) {
      console.error('Error enviando por WhatsApp:', error);
      toast.error('Error al enviar reporte por WhatsApp: ' + (error.response?.data?.detail || error.message));
    } finally {
      setEnviandoWA(false);
    }
  };


  const toggleGrabarTeam = (idx) => {
    setTeamsGrabados(prev => {
      const next = new Set(prev);
      if (next.has(idx)) {
        next.delete(idx);
      } else {
        next.add(idx);
      }
      return next;
    });
  };

  const exportarReporteTeams = () => {
    const teamsSeleccionados = [...teamsGrabados].map(idx => teams[idx]).filter(Boolean);
    if (teamsSeleccionados.length === 0) {
      toast.error('No hay teams grabados');
      return;
    }

    // Recopilar todos los IDs
    const allBrIds = [];
    const allArIds = [];
    teamsSeleccionados.forEach(team => {
      (team.br_ids || []).forEach(id => {
        if (!allBrIds.includes(id)) allBrIds.push(id);
      });
      (team.ar_ids || []).forEach(id => {
        if (!allArIds.includes(id)) allArIds.push(id);
      });
    });

    // Armar filas: columna BR | columna AR
    const maxLen = Math.max(allBrIds.length, allArIds.length);
    const rows = [['IDs Brasil', 'IDs Argentina']];
    for (let i = 0; i < maxLen; i++) {
      rows.push([allBrIds[i] || '', allArIds[i] || '']);
    }

    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws['!cols'] = [{ wch: 20 }, { wch: 20 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'IDs Sospechosos');
    XLSX.writeFile(wb, `reporte_teams_chip_dumping_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success(`Reporte generado: ${allBrIds.length} IDs BR + ${allArIds.length} IDs AR`);
  };

  const getNivelBadge = (nivel) => {
    const styles = {
      CRITICO: 'bg-red-600 text-white animate-pulse',
      ALTO: 'bg-orange-500 text-white',
      MEDIO: 'bg-yellow-400 text-gray-900',
      BAJO: 'bg-gray-300 text-gray-700',
    };
    return styles[nivel] || 'bg-gray-200';
  };

  const formatMoney = (num) => {
    if (num === null || num === undefined) return '0.00';
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  return (
    <div className="space-y-4" data-testid="chip-dumping-tab">
      {/* Tarjetas Resumen */}
      {resumen ? (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="chip-dumping-summary">
          <div className="bg-red-50 dark:bg-red-900/30 border-2 border-red-400 dark:border-red-600 rounded-xl p-4 text-center">
            <p className="text-3xl font-black text-red-600 dark:text-red-400">{resumen.alertas_criticas || 0}</p>
            <p className="text-xs font-bold text-red-800 dark:text-red-300 mt-1">CRITICAS</p>
          </div>
          <div className="bg-orange-50 dark:bg-orange-900/30 border-2 border-orange-400 dark:border-orange-600 rounded-xl p-4 text-center">
            <p className="text-3xl font-black text-orange-600 dark:text-orange-400">{resumen.alertas_altas || 0}</p>
            <p className="text-xs font-bold text-orange-800 dark:text-orange-300 mt-1">ALTAS</p>
          </div>
          <div className="bg-yellow-50 dark:bg-yellow-900/30 border-2 border-yellow-400 dark:border-yellow-600 rounded-xl p-4 text-center">
            <p className="text-3xl font-black text-yellow-600 dark:text-yellow-500">{resumen.alertas_medias || 0}</p>
            <p className="text-xs font-bold text-yellow-800 dark:text-yellow-300 mt-1">MEDIAS</p>
          </div>
          <div className="bg-blue-50 dark:bg-blue-900/30 border-2 border-blue-400 dark:border-blue-600 rounded-xl p-4 text-center">
            <p className="text-3xl font-black text-blue-600 dark:text-blue-400">{resumen.total_alertas || 0}</p>
            <p className="text-xs font-bold text-blue-800 dark:text-blue-300 mt-1">TOTAL ALERTAS</p>
          </div>
          <div className="bg-purple-50 dark:bg-purple-900/30 border-2 border-purple-400 dark:border-purple-600 rounded-xl p-4 text-center">
            <p className="text-3xl font-black text-purple-600 dark:text-purple-400">{resumen.total_teams || 0}</p>
            <p className="text-xs font-bold text-purple-800 dark:text-purple-300 mt-1">TEAMS</p>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 dark:bg-gray-800 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-8 text-center">
          <Shield className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-500 dark:text-gray-400 font-semibold">No hay analisis previos</p>
          <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">Ejecuta un analisis para detectar Chip Dumping</p>
        </div>
      )}

      {/* Controles: Ejecutar + Exportar */}
      <div className="bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20 rounded-xl border-2 border-red-300 dark:border-red-700 p-4" data-testid="chip-dumping-controls">
        <div className="flex flex-col md:flex-row items-end gap-4">
          <div className="flex-1">
            <label className="block text-sm font-bold text-red-800 dark:text-red-300 mb-2">
              Ejecutar Analisis de Chip Dumping
            </label>
            <p className="text-xs text-red-700 dark:text-red-400 mb-3">
              Cruza datos BR vs AR detectando transferencia ilicita de fichas. Dejar fechas vacias = historico completo.
            </p>
            <div className="flex gap-3 flex-wrap">
              <div>
                <span className="block text-xs text-red-700 dark:text-red-400 mb-1 font-semibold">Desde</span>
                <input
                  type="date"
                  value={fechaDesde}
                  onChange={(e) => setFechaDesde(e.target.value)}
                  className="w-44 px-3 py-2 border-2 border-red-300 dark:border-red-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm"
                  data-testid="chip-dumping-fecha-desde"
                />
              </div>
              <div>
                <span className="block text-xs text-red-700 dark:text-red-400 mb-1 font-semibold">Hasta</span>
                <input
                  type="date"
                  value={fechaHasta}
                  onChange={(e) => setFechaHasta(e.target.value)}
                  className="w-44 px-3 py-2 border-2 border-red-300 dark:border-red-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm"
                  data-testid="chip-dumping-fecha-hasta"
                />
              </div>
              <div>
                <span className="block text-xs text-red-700 dark:text-red-400 mb-1 font-semibold">Investigar Jugador</span>
                <div className="relative">
                  <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-red-400" />
                  <input
                    type="text"
                    value={filtroJugador}
                    onChange={(e) => setFiltroJugador(e.target.value)}
                    placeholder="ID o nombre..."
                    className="w-48 pl-9 pr-3 py-2 border-2 border-red-300 dark:border-red-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm"
                    data-testid="chip-dumping-filtro-jugador"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={ejecutarAnalisis}
              disabled={ejecutandoAnalisis}
              data-testid="chip-dumping-ejecutar-btn"
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-bold transition-all ${
                ejecutandoAnalisis
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl'
              }`}
            >
              {ejecutandoAnalisis ? (
                <>
                  <RefreshCw className="w-5 h-5 animate-spin" />
                  Analizando...
                </>
              ) : (
                <>
                  <Play className="w-5 h-5" />
                  Ejecutar Analisis
                </>
              )}
            </button>
            <button
              onClick={() => exportarDenuncia()}
              disabled={!resumen}
              data-testid="chip-dumping-exportar-btn"
              className="flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-bold transition-all disabled:bg-gray-400 disabled:cursor-not-allowed shadow-lg"
            >
              <Download className="w-5 h-5" />
              Exportar Denuncia
            </button>
          </div>
        </div>

        {resumen && (
          <div className="mt-3 text-xs text-red-700 dark:text-red-400">
            Ultimo analisis: {new Date(resumen.fecha_analisis).toLocaleString('es-AR')} | Datos: {resumen.fecha_datos === 'HISTORICO_COMPLETO' ? 'Historico Completo' : resumen.fecha_datos}
          </div>
        )}
      </div>

      {/* Filtros por Nivel */}
      <div className="flex gap-2 flex-wrap items-center" data-testid="chip-dumping-filtros-nivel">
        {['', 'CRITICO', 'ALTO', 'MEDIO', 'BAJO'].map(nivel => (
          <button
            key={nivel || 'TODOS'}
            onClick={() => setFiltroNivel(nivel)}
            data-testid={`chip-dumping-filtro-${nivel || 'todos'}`}
            className={`px-4 py-2 rounded-lg font-semibold text-sm transition-all ${
              filtroNivel === nivel
                ? (nivel === 'CRITICO' ? 'bg-red-600 text-white shadow-lg'
                  : nivel === 'ALTO' ? 'bg-orange-500 text-white shadow-lg'
                  : nivel === 'MEDIO' ? 'bg-yellow-400 text-gray-900 shadow-lg'
                  : nivel === 'BAJO' ? 'bg-gray-500 text-white shadow-lg'
                  : 'bg-blue-600 text-white shadow-lg')
                : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
            }`}
          >
            {nivel || 'TODOS'}
          </button>
        ))}
        <span className="text-sm text-gray-500 dark:text-gray-400 ml-2">
          Mostrando {alertas.length} de {totalAlertas} alertas
        </span>
        {alertasGrabadas.size > 0 && (
          <div className="flex items-center gap-2 ml-auto">
            <button
              onClick={exportarReporteAlertas}
              data-testid="exportar-reporte-alertas"
              className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-bold text-sm transition-all shadow-lg"
            >
              <FileSpreadsheet className="w-4 h-4" />
              Reportar {alertasGrabadas.size} pares
            </button>
            <button
              onClick={enviarPorWhatsApp}
              disabled={enviandoWA}
              data-testid="enviar-whatsapp-btn"
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-sm transition-all shadow-lg ${
                enviandoWA
                  ? 'bg-gray-400 cursor-not-allowed text-white'
                  : 'bg-[#25D366] hover:bg-[#128C7E] text-white'
              }`}
              title="Enviar reporte al grupo PP Seguridad por WhatsApp"
            >
              {enviandoWA ? (
                <>
                  <RefreshCw className="w-4 h-4 animate-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  <Send className="w-4 h-4" />
                  WhatsApp
                </>
              )}
            </button>
          </div>
        )}
      </div>

      {/* Boton Importar Respuesta PPPoker */}
      <div className="flex justify-end mb-2">
        <label className={`flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-sm cursor-pointer transition-all shadow ${
          importandoResp ? 'bg-gray-400 text-white' : 'bg-blue-600 hover:bg-blue-700 text-white'
        }`}>
          {importandoResp ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {importandoResp ? 'Importando...' : 'Importar Respuesta PPPoker'}
          <input type="file" accept=".xlsx,.xls" onChange={importarRespuestaPPPoker} className="hidden" disabled={importandoResp} />
        </label>
      </div>

      {/* Confirmados por PPPoker */}
      {confirmadosCD.length > 0 && (
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 shadow mb-4">
          <button
            onClick={() => setShowConfirmados(!showConfirmados)}
            className="w-full flex items-center justify-between cursor-pointer hover:bg-green-100 rounded-lg p-1 transition-colors"
          >
            <h3 className="font-bold text-green-800">
              Confirmados por PPPoker: {confirmadosCD.length} pares ({confirmadosCD.filter(c => c.tipo_confirmado === 'Chip Dumping').length} Chip Dumping, {confirmadosCD.filter(c => c.tipo_confirmado === 'Colusion').length} Colusion)
            </h3>
            {showConfirmados ? <ChevronUp className="w-5 h-5 text-green-600" /> : <ChevronDown className="w-5 h-5 text-green-600" />}
          </button>
          {showConfirmados && (
            <div className="space-y-3 mt-3">
              {confirmadosCD.map((par, idx) => (
                <div key={idx} className="bg-white border border-green-300 rounded-lg p-3 shadow-sm">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className={`text-xs px-2 py-0.5 rounded font-bold ${
                      par.tipo_confirmado === 'Chip Dumping' ? 'bg-red-100 text-red-700' : 'bg-purple-100 text-purple-700'
                    }`}>{par.tipo_confirmado}</span>
                    <span className="text-sm font-semibold text-gray-700">Score: {par.score}</span>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <div className="flex items-center gap-1 bg-red-50 border border-red-200 px-3 py-1 rounded-lg text-sm">
                      <span className="text-xs text-red-500 font-semibold">BR:</span>
                      <span className="font-bold text-red-800">{par.br_id}</span>
                      <span className="text-red-700">{par.br_nombre}</span>
                      <span className="text-xs text-gray-500">({par.br_club})</span>
                    </div>
                    <div className="flex items-center gap-1 bg-green-50 border border-green-200 px-3 py-1 rounded-lg text-sm">
                      <span className="text-xs text-green-500 font-semibold">AR:</span>
                      <span className="font-bold text-green-800">{par.ar_id}</span>
                      <span className="text-green-700">{par.ar_nombre}</span>
                      <span className="text-xs text-gray-500">({par.ar_club})</span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-gray-600">
                      <span>BR: <span className={par.br_ganancia < 0 ? 'text-red-600 font-bold' : 'text-green-600 font-bold'}>{par.br_ganancia?.toFixed(2)}</span></span>
                      <span>AR: <span className={par.ar_ganancia > 0 ? 'text-green-600 font-bold' : 'text-red-600 font-bold'}>{par.ar_ganancia?.toFixed(2)}</span></span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Tabla de Alertas */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden" data-testid="chip-dumping-tabla-alertas">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gradient-to-r from-red-600 to-red-800 text-white">
                <th className="px-3 py-3 text-left font-bold">Nivel</th>
                <th className="px-3 py-3 text-center font-bold">Score</th>
                <th className="px-3 py-3 text-left font-bold">BR ID</th>
                <th className="px-3 py-3 text-left font-bold">BR Nombre</th>
                <th className="px-3 py-3 text-left font-bold">BR Club</th>
                <th className="px-3 py-3 text-left font-bold">AR ID</th>
                <th className="px-3 py-3 text-left font-bold">AR Nombre</th>
                <th className="px-3 py-3 text-left font-bold">AR Club</th>
                <th className="px-3 py-3 text-center font-bold">Mesas</th>
                <th className="px-3 py-3 text-right font-bold">BR Gan.</th>
                <th className="px-3 py-3 text-right font-bold">AR Gan.</th>
                <th className="px-3 py-3 text-left font-bold">Razones</th>
                <th className="px-3 py-3 text-center font-bold">Estado</th>
                <th className="px-3 py-3 text-center font-bold">VS</th>
                <th className="px-3 py-3 text-center font-bold">Grabar</th>
              </tr>
            </thead>
            <tbody>
              {alertas.length === 0 ? (
                <tr>
                  <td colSpan={15} className="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
                    {loading ? (
                      <div className="flex items-center justify-center gap-2">
                        <RefreshCw className="w-5 h-5 animate-spin" />
                        Cargando alertas...
                      </div>
                    ) : 'No hay alertas. Ejecuta un analisis primero.'}
                  </td>
                </tr>
              ) : alertas.map((a, idx) => (
                <tr
                  key={a.alerta_id || idx}
                  data-testid={`alerta-row-${idx}`}
                  className="border-b border-gray-100 dark:border-gray-700 hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors"
                >
                  <td className="px-3 py-2">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${getNivelBadge(a.nivel)}`}>
                      {a.nivel}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-center font-bold text-lg">{a.score}</td>
                  <td className="px-3 py-2 font-mono text-xs">{a.br_id}</td>
                  <td className="px-3 py-2 font-semibold text-xs">{a.br_nombre}</td>
                  <td className="px-3 py-2 text-xs text-gray-600 dark:text-gray-400">{a.br_club_nombre}</td>
                  <td className="px-3 py-2 font-mono text-xs">{a.ar_id}</td>
                  <td className="px-3 py-2 font-semibold text-xs">{a.ar_nombre}</td>
                  <td className="px-3 py-2 text-xs text-gray-600 dark:text-gray-400">{a.ar_club_nombre}</td>
                  <td className="px-3 py-2 text-center font-bold">{a.total_mesas}</td>
                  <td className={`px-3 py-2 text-right font-semibold text-xs ${a.br_ganancia_total < 0 ? 'text-red-600' : 'text-green-600'}`}>
                    {formatMoney(a.br_ganancia_total)}
                  </td>
                  <td className={`px-3 py-2 text-right font-semibold text-xs ${a.ar_ganancia_total < 0 ? 'text-red-600' : 'text-green-600'}`}>
                    {formatMoney(a.ar_ganancia_total)}
                  </td>
                  <td className="px-3 py-2 text-xs max-w-[200px]">
                    <div className="space-y-0.5">
                      {(a.razones || []).map((r, rIdx) => (
                        <div key={rIdx} className="flex items-start gap-1">
                          <AlertTriangle className="w-3 h-3 text-orange-500 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-600 dark:text-gray-400 leading-tight">{r}</span>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="px-3 py-2 text-center">
                    {a.ya_reportado ? (
                      <div className="flex flex-col items-center gap-0.5" title={`Tracking: ${a.tracking}`}>
                        <CheckCircle className="w-4 h-4 text-green-600" />
                        <span className="text-[10px] font-bold text-green-600">ENVIADO</span>
                        <span className="text-[9px] text-gray-400 font-mono">{a.tracking}</span>
                      </div>
                    ) : (
                      <span className="text-[10px] text-gray-400">Nuevo</span>
                    )}
                  </td>
                  <td className="px-3 py-2 text-center">
                    <button
                      onClick={() => verDetallePar(a.br_id, a.ar_id)}
                      data-testid={`ver-vs-${idx}`}
                      className="p-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                      title="Ver detalle VS"
                    >
                      <Eye className="w-4 h-4" />
                    </button>
                  </td>
                  <td className="px-3 py-2 text-center">
                    {a.ya_reportado ? (
                      <CheckCircle className="w-4 h-4 text-green-500 mx-auto" title="Ya reportado" />
                    ) : (
                      <button
                        onClick={() => toggleGrabarAlerta(idx)}
                        data-testid={`grabar-alerta-${idx}`}
                        className={`p-1.5 rounded-lg transition-all ${
                          alertasGrabadas.has(idx)
                            ? 'bg-green-600 text-white shadow-md'
                            : 'bg-gray-200 dark:bg-gray-600 text-gray-500 dark:text-gray-400 hover:bg-green-100 dark:hover:bg-green-900/30'
                        }`}
                        title={alertasGrabadas.has(idx) ? 'Grabado - click para quitar' : 'Grabar par'}
                      >
                        <Bookmark className="w-4 h-4" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Teams Sospechosos */}
      {teams.length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4" data-testid="chip-dumping-teams">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-bold text-gray-800 dark:text-gray-200 flex items-center gap-2">
              <Users className="w-5 h-5 text-purple-600" />
              Teams Sospechosos ({teams.length})
              {teamsGrabados.size > 0 && (
                <span className="text-sm font-normal text-green-600 dark:text-green-400 ml-2">
                  ({teamsGrabados.size} grabados)
                </span>
              )}
            </h3>
            {teamsGrabados.size > 0 && (
              <button
                onClick={exportarReporteTeams}
                data-testid="exportar-reporte-teams"
                className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-bold text-sm transition-all shadow-lg"
              >
                <FileSpreadsheet className="w-4 h-4" />
                Reportar ({teamsGrabados.size})
              </button>
            )}
          </div>

          <div className="space-y-3">
            {teams.slice(0, 20).map((team, idx) => (
              <div
                key={team.team_id || idx}
                data-testid={`team-row-${idx}`}
                className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden"
              >
                <div
                  className="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                  onClick={() => setExpandedTeam(expandedTeam === idx ? null : idx)}
                >
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${getNivelBadge(team.nivel)}`}>
                      {team.nivel}
                    </span>
                    <span className="font-semibold text-sm text-green-700 dark:text-green-400">{team.br_club_nombre}</span>
                    <span className="text-gray-400 text-xs">VS</span>
                    <span className="font-semibold text-sm text-blue-700 dark:text-blue-400">{team.ar_club_nombre}</span>
                    <span className="text-xs text-gray-500 bg-gray-100 dark:bg-gray-700 px-2 py-0.5 rounded">
                      Score: {team.score_total}
                    </span>
                    <span className="text-xs text-gray-500">
                      BR: {team.br_ids?.length || 0} IDs | AR: {team.ar_ids?.length || 0} IDs
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={(e) => { e.stopPropagation(); toggleGrabarTeam(idx); }}
                      data-testid={`grabar-team-${idx}`}
                      className={`p-1.5 rounded-lg transition-all ${
                        teamsGrabados.has(idx)
                          ? 'bg-green-600 text-white shadow-md'
                          : 'bg-gray-200 dark:bg-gray-600 text-gray-500 dark:text-gray-400 hover:bg-green-100 dark:hover:bg-green-900/30'
                      }`}
                      title={teamsGrabados.has(idx) ? 'Grabado - click para quitar' : 'Grabar team'}
                    >
                      <Bookmark className="w-4 h-4" />
                    </button>
                    {expandedTeam === idx ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
                  </div>
                </div>

                {expandedTeam === idx && (
                  <div className="border-t border-gray-200 dark:border-gray-700 p-3 bg-gray-50 dark:bg-gray-900/50">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm font-bold text-green-700 dark:text-green-400 mb-2">IDs Brasil ({team.br_ids?.length || 0})</p>
                        <div className="flex flex-wrap gap-1">
                          {(team.br_ids || []).map(id => (
                            <span key={id} className="px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 rounded text-xs font-mono">
                              {id}
                            </span>
                          ))}
                        </div>
                      </div>
                      <div>
                        <p className="text-sm font-bold text-blue-700 dark:text-blue-400 mb-2">IDs Argentina ({team.ar_ids?.length || 0})</p>
                        <div className="flex flex-wrap gap-1">
                          {(team.ar_ids || []).map(id => (
                            <span key={id} className="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 rounded text-xs font-mono">
                              {id}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Historial de Analisis */}
      {historial.length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4" data-testid="chip-dumping-historial">
          <h3 className="text-lg font-bold text-gray-800 dark:text-gray-200 mb-3">
            Historial de Analisis
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-100 dark:bg-gray-700">
                  <th className="px-3 py-2 text-left font-bold">Fecha</th>
                  <th className="px-3 py-2 text-left font-bold">Datos</th>
                  <th className="px-3 py-2 text-center font-bold">Total</th>
                  <th className="px-3 py-2 text-center font-bold text-red-600">Criticas</th>
                  <th className="px-3 py-2 text-center font-bold text-orange-600">Altas</th>
                  <th className="px-3 py-2 text-center font-bold text-yellow-600">Medias</th>
                  <th className="px-3 py-2 text-center font-bold text-purple-600">Teams</th>
                  <th className="px-3 py-2 text-center font-bold">Excel</th>
                </tr>
              </thead>
              <tbody>
                {historial.map((h, idx) => (
                  <tr key={h.analisis_id || idx} className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                    <td className="px-3 py-2 text-xs">{new Date(h.fecha_analisis).toLocaleString('es-AR')}</td>
                    <td className="px-3 py-2 text-xs">{h.fecha_datos === 'HISTORICO_COMPLETO' ? 'Historico' : h.fecha_datos}</td>
                    <td className="px-3 py-2 text-center font-bold">{h.total_alertas}</td>
                    <td className="px-3 py-2 text-center font-bold text-red-600">{h.alertas_criticas}</td>
                    <td className="px-3 py-2 text-center font-bold text-orange-600">{h.alertas_altas}</td>
                    <td className="px-3 py-2 text-center font-bold text-yellow-600">{h.alertas_medias}</td>
                    <td className="px-3 py-2 text-center font-bold text-purple-600">{h.total_teams}</td>
                    <td className="px-3 py-2 text-center">
                      <button
                        onClick={() => exportarDenuncia(h.analisis_id)}
                        data-testid={`exportar-historial-${idx}`}
                        className="p-1.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
                        title="Descargar Excel de denuncia"
                      >
                        <Download className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal VS Detalle */}
      {showVsModal && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => setShowVsModal(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="bg-gradient-to-r from-red-600 to-orange-600 p-4 text-white flex justify-between items-center">
              <h3 className="text-lg font-bold" data-testid="vs-modal-title">
                Detalle VS: {vsData?.j1_nombre || vsData?.j1_id} vs {vsData?.j2_nombre || vsData?.j2_id}
              </h3>
              <button onClick={() => setShowVsModal(false)} className="p-1 hover:bg-white/20 rounded" data-testid="vs-modal-close">
                <X className="w-6 h-6" />
              </button>
            </div>

            {loadingVs ? (
              <div className="p-8 text-center">
                <RefreshCw className="w-8 h-8 animate-spin mx-auto text-red-500" />
                <p className="mt-2 text-gray-500">Cargando detalle...</p>
              </div>
            ) : vsData && (
              <div className="p-4 overflow-y-auto max-h-[75vh]">
                {/* Resumen VS */}
                <div className="grid grid-cols-3 gap-4 mb-4" data-testid="vs-summary">
                  <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-4 text-center border border-green-200 dark:border-green-700">
                    <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Jugador 1 (BR)</p>
                    <p className="font-bold text-sm">{vsData.j1_nombre || vsData.j1_id}</p>
                    <p className="text-xs font-mono text-gray-400 dark:text-gray-500">ID: {vsData.j1_id}</p>
                    <p className="text-xs text-gray-500 mt-1">{vsData.j1_total_mesas} mesas totales</p>
                    <p className={`font-bold text-xl mt-2 ${vsData.j1_ganancia_total < 0 ? 'text-red-600' : 'text-green-600'}`}>
                      {formatMoney(vsData.j1_ganancia_total)}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">Cuota: {formatMoney(vsData.j1_cuota_total)}</p>
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 text-center flex flex-col justify-center border border-gray-200 dark:border-gray-600">
                    <p className="text-4xl font-black text-red-600">{vsData.mesas_comunes}</p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Mesas en Comun</p>
                    {vsData.j1_total_mesas > 0 && vsData.j2_total_mesas > 0 && (
                      <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-600 space-y-0.5">
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          <span className="font-bold text-green-700 dark:text-green-400">{Math.round((vsData.mesas_comunes / vsData.j1_total_mesas) * 100)}%</span> de J1
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          <span className="font-bold text-blue-700 dark:text-blue-400">{Math.round((vsData.mesas_comunes / vsData.j2_total_mesas) * 100)}%</span> de J2
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 text-center border border-blue-200 dark:border-blue-700">
                    <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Jugador 2 (AR)</p>
                    <p className="font-bold text-sm">{vsData.j2_nombre || vsData.j2_id}</p>
                    <p className="text-xs font-mono text-gray-400 dark:text-gray-500">ID: {vsData.j2_id}</p>
                    <p className="text-xs text-gray-500 mt-1">{vsData.j2_total_mesas} mesas totales</p>
                    <p className={`font-bold text-xl mt-2 ${vsData.j2_ganancia_total < 0 ? 'text-red-600' : 'text-green-600'}`}>
                      {formatMoney(vsData.j2_ganancia_total)}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">Cuota: {formatMoney(vsData.j2_cuota_total)}</p>
                  </div>
                </div>

                {/* Tabla detalle mesas */}
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-gray-100 dark:bg-gray-700 text-xs">
                        <th className="px-3 py-2 text-left font-bold">Fecha</th>
                        <th className="px-3 py-2 text-left font-bold">Mesa</th>
                        <th className="px-3 py-2 text-right font-bold text-green-700">J1 Gan.</th>
                        <th className="px-3 py-2 text-right font-bold text-green-700">J1 Cuota</th>
                        <th className="px-3 py-2 text-center font-bold text-green-700">J1 Manos</th>
                        <th className="px-3 py-2 text-right font-bold text-blue-700">J2 Gan.</th>
                        <th className="px-3 py-2 text-right font-bold text-blue-700">J2 Cuota</th>
                        <th className="px-3 py-2 text-center font-bold text-blue-700">J2 Manos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vsData.detalle?.map((d, idx) => (
                        <tr key={idx} className="border-b border-gray-100 dark:border-gray-700 text-xs hover:bg-gray-50 dark:hover:bg-gray-700/30">
                          <td className="px-3 py-1.5">{d.fecha}</td>
                          <td className="px-3 py-1.5 font-mono">{d.partida_id}</td>
                          <td className={`px-3 py-1.5 text-right font-semibold ${d.j1_ganancia < 0 ? 'text-red-600' : 'text-green-600'}`}>
                            {formatMoney(d.j1_ganancia)}
                          </td>
                          <td className="px-3 py-1.5 text-right">{formatMoney(d.j1_cuota)}</td>
                          <td className="px-3 py-1.5 text-center">{d.j1_manos}</td>
                          <td className={`px-3 py-1.5 text-right font-semibold ${d.j2_ganancia < 0 ? 'text-red-600' : 'text-green-600'}`}>
                            {formatMoney(d.j2_ganancia)}
                          </td>
                          <td className="px-3 py-1.5 text-right">{formatMoney(d.j2_cuota)}</td>
                          <td className="px-3 py-1.5 text-center">{d.j2_manos}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
